import * as React from "react";
import {createIntl, createIntlCache, RawIntlProvider} from "react-intl";
import {connect} from "react-redux";
import {planLanguageId} from "../../../mainReducerMapSelectors";
import {getIntlProps} from "../common/intlUtils";
import {setIntl} from "../../utils/translationUtil";
import {IApplicationRootState} from "../../../applicationState";

interface InitializeIntlStateProps {
    planLanguageId: number;
}

interface InitializeIntlOwnProps {
    children?: React.ReactNode;
}

type InitializeIntlAllProps = InitializeIntlStateProps & InitializeIntlOwnProps;

export const InitializeIntlComponent: React.FunctionComponent<InitializeIntlAllProps> = (props) => {
    const cache = createIntlCache();
    const intlProps = getIntlProps(props.planLanguageId);
    const intl = createIntl({...intlProps}, cache);
    setIntl(intl);
    return <RawIntlProvider value={intl}>{props.children}</RawIntlProvider>;
};

export const mapStateToProps = (state: IApplicationRootState): InitializeIntlStateProps => ({
    planLanguageId: planLanguageId(state),
});

export default connect<
    InitializeIntlStateProps,   // StateProps
    {},                         // DispatchProps
    InitializeIntlOwnProps,     // OwnProps (children)
    IApplicationRootState       // RootState
>(mapStateToProps)(InitializeIntlComponent);
